import { Autocomplete, Button, Paper, Text, Box, Flex, Group } from '@mantine/core';
import classes from './ManageDisposal.module.css';
import { IoAdd } from "react-icons/io5";
import { IoMdSearch } from "react-icons/io";

import React, { memo, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import InputButton from '../../../CustomComponent/InputFileButton/Inputbutton.component';
import { baseUrl } from '../../../Constants/constant';
import SampleFile from '../../../CustomComponent/DownloadSampleFile/Samplefile.component';
import DisposalDataTableComponent from './DisposalDataTable.component';

const ManageDisposal = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [sendsearch, setSendsearch] = useState('');

  const handlechange = (value: any) => {
    setSearch(value);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setSendsearch(search);
    }, 500); // Debounce input for better performance

    return () => clearTimeout(timeout); // Cleanup on re-renders
  }, [search]);

  return (
    <>

      <Paper shadow="xs" p="xs" radius="md">
        <Box>
          <Flex
            style={{ justifyContent: 'space-between' }}
            align="center"
          >
            <Box>
              <Text ta="left">Disposal</Text>
            </Box>
            <Group>
              <Autocomplete
                // label="Your favorite library"
                value={search}
                onChange={handlechange}
                placeholder="Search by Disposal"
                leftSection={<IoMdSearch />}
              />

              <Button
                className={classes.addbtn}
                variant="gradient"
                gradient={{ from: '#404040', to: '#404040', deg: 90 }}
                leftSection={<IoAdd size={20} />}
                onClick={() => navigate('/disposal/add-disposal')}
              >
                Add Disposal
              </Button>
              <InputButton
                url={`${baseUrl}admin/end-life/import-file`}
              />
              <SampleFile type={'disposal'} />
            </Group>
          </Flex>
          <DisposalDataTableComponent editLink={'/disposal/add-disposal'} search={sendsearch} />
        </Box>
      </Paper>
    </>
  )
}

export default memo(ManageDisposal)
